import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { useAppDispatch } from "../../../store/hooks";
import { fetchTips } from "../../../actions/mine_craft/tipsActions";
import { queryParams } from "../../../helpers/UrlHelpers";

import Wrapper from "../../../componets/Wrapper";
import NavBarThree from "../../../componets/NavBarThree";
import { PlusOutlined } from "@ant-design/icons";
import { setNewParams } from "../../../store/mine_craft/tipsSlice";
import PageLayout from '../_partials/PageLayout';
import PageHeader from "../../../componets/PageHeader";
import List from "./_partials/_List";
import SidebarIndex from "./_partials/_SidebarIndex";
import New from "./New";
import Edit from "./Edit";
import Can from "../../../componets/Can";

import './style.scss';

const LIMIT = 50;

export interface PropsInterface {
  entityId: 1 | 2;
}

const Tips = ({ entityId }: PropsInterface) => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;

  useEffect(() => {
    const params: any = {
      entity_id:  entityId,
      limit:      LIMIT,
      offset:     (currentPage - 1) * LIMIT
    };

    dispatch(fetchTips(params))
  }, [currentPage, dispatch]);

  function onClickCreate() {
    const params: any = {
      entity_id:  entityId
    };

    dispatch(setNewParams(params));
  }

  return (
    <PageLayout className='v-tips-page'>
      <PageHeader
        title='Helps'
      />

      <Can capability='write_minecraft'>
        <Wrapper>
          <NavBarThree>
            <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
              <PlusOutlined /> Create Help
            </NavBarThree.Button>
          </NavBarThree>
        </Wrapper>
      </Can>

      <div className='v-container'>
        <List limit={LIMIT} />
      </div>

      <SidebarIndex />

      <New />
      <Edit />
    </PageLayout>
  );
}

export default Tips;
